import { Spin } from 'antd';
import { WaterfallChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Data {
  categories: string[];
  data: Array<{ name: string; value: number; isTotal?: boolean }>;
}

function WaterfallWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'waterfall', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <WaterfallChart categories={data?.categories ?? []} data={data?.data ?? []} />;
}

export const waterfallWidgetDef: WidgetDefinition = {
  type: 'waterfall',
  name: 'Waterfall Chart',
  description: 'Incremental composition',
  icon: 'ArrowDownOutlined',
  category: 'chart',
  defaultTitle: 'Waterfall',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: WaterfallWidget,
  settingsSchema: { fields: [] },
};
